import { z } from "zod";

enum ApplianceNotEquippedByVoltalis {
  RADIATOR = "RADIATOR",
  TOWEL_DRYER = "TOWEL_DRYER",
  OTHER = "OTHER",
}

const applianceNotEquippedByVoltalisEnum = z.nativeEnum(ApplianceNotEquippedByVoltalis);

enum HPApplianceEquipped {
  HEAT_PUMP = "HEAT_PUMP",
  REVERSIBLE_AIR_CONDITIONING = "REVERSIBLE_AIR_CONDITIONING",
  HEATING_FLOOR = "HEATING_FLOOR",
}

const hpApplianceEquippedEnum = z.nativeEnum(HPApplianceEquipped);

export const escNonEligibilityReportDtoSchema = z.object({
  allRoomsAreEquippedByVoltalis: z.boolean().nullish(),
  buildingIsOlderThan2years: z.boolean().nullish(),
  hasHeatPump: z.boolean(),
  isNotPro: z.boolean(),
  applianceNotEquippedByVoltalis: applianceNotEquippedByVoltalisEnum.nullish(),
  applianceNotEquippedByVoltalisReason: z.string().nullish(),
  hpApplianceEquipped: hpApplianceEquippedEnum.nullish(),
  hpApplianceEquippedReason: z.string().nullish(),
  hpModelId: z.number().nullish(),
  personId: z.number().nullish(),
});

export type TEscNonEligiblityReportDto = z.infer<typeof escNonEligibilityReportDtoSchema>;
